<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            title="LABEL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <div class="vx-row">
      <div class="vx-col w-1/5">
        <v-select :clearable="false" label="name" v-model="print_pack_size"
                  :reduce="option => option.value"
                  :options="[{ name: 'Print 5Kg version', value: 5 }, { name: 'Print 10Kg version', value: 10 }]"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
      </div>
      <div class="vx-col w-1/5">
        <vs-button class="mb-8" @click="onClickPrint()" color="warning" type="border" >Print</vs-button>
      </div>
    </div>
    <body id="printDiv">
    <div id="full-wrap" style="font-size: 10px !important;">
      <main class="leading-loose p-base">
        <vx-card id="formulation-label-pop-up" no-shadow class="bg-white" style="color: #000000 !important;">
      <div class="vx-row mb-2 mt-0">
        <h3 class="ml-8 uppercase font-semibold" style="color: #000000; font-size: 15px !important;">
          {{ orderDetails.formulation_name }} {{ orderDetails.formulation_code }}
        </h3>
      </div>
      <div class="vx-row mt-0">
        <div class="vx-col w-2/5 md:mb-0">
          <div class="grid grid-cols-2">
            <div v-for="(img, index)  in label_images" :key="'image'+index">
              <img class="responsive" :src="'https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/'+img" alt="">
            </div>
          </div>
        </div>
        <div class="vx-col w-3/5 md:mb-0">
          <div class="vx-row">
            <div class="vx-col 1/3">
              Customer Product Code
            </div>
            <div class="vx-col 2/3">
              {{ customer_item_code || orderDetails.formulation_code }}
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col 1/3">
              Legal Name
            </div>
            <div class="vx-col 2/3">
              {{ orderDetails.formulation_legal_name || 'N/A' }}
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col 1/3">
              Batch
            </div>
            <div class="vx-col 2/3">
              {{orderDetails.work_order_code}}/{{orderDetails.formulation_code}}
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col 1/3">
              Weight (KG)
            </div>
            <div class="vx-col 2/3">
              {{ print_pack_size }}
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col 1/3">
              Manufactured
            </div>
            <div class="vx-col 2/3">
              {{orderDetails.work_order_date}}
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col 1/3">
              Best Before
            </div>
            <div class="vx-col 2/3">
              {{ best_before }}
            </div>
          </div>
          <div class="vx-row" v-if="orderDetails.storage_condition">
            <div class="vx-col 1/3">

            </div>
            <div class="vx-col 2/3">
              {{ orderDetails.storage_condition || 'N/A' }}
            </div>
          </div>
          <h6 class="mb-0 mt-2 ml-2" style="color: #000000; font-size: 12px !important;">Danger</h6>
          <span class="ml-2" v-for="(label , index) in groupedLabelData.EHSHP" :key="'danger1'+index">
            {{ label.data.split('-')[1] }} <br>
          </span>
          <span class="ml-2 " v-for="(label , index) in groupedLabelData.EHSPO" :key="'danger2'+index">
            {{ label.data.split('-')[1] }} <br>
          </span>
          <span class="ml-2" v-for="(label , index) in groupedLabelData.EGOH" :key="'danger3'+index">
            {{ label.data }} <br>
          </span>
          <span class="ml-2" v-for="(label , index) in groupedLabelData.RU" :key="'danger4'+index">
            {{ label.data }} <br>
          </span>
          <span class="ml-2" v-for="(label , index) in groupedLabelData.FPC" :key="'danger5'+index">
            {{ label.caption }} - {{ label.data }} <br>
          </span>
<!--          <span class="ml-12" v-for="(label , index) in groupedLabelData.ESPI" :key="'other_info'+index">-->
<!--            {{ label.data }} <br>-->
<!--          </span>-->
          <span class="ml-2">
            {{ UNI }}, {{ PYST }}, {{ ODR }}, {{ PGI }}
          </span> <br>
          <span class="ml-8 mt-0" style="font-size: 25px; color: #000000 !important;" > {{ UNI }} </span>
        </div>
      </div>
      <div class="vx-row mb-0 mt-0">
        <div class="vx-col w-2/5 md:mb-0">

        </div>
        <div class="vx-col w-3/5 md:mb-0">
          <img v-if="is_halal" id="logo" class="ml-2" style="display: inline-block;"
               src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/halal.jpg"
               alt="Halal Logo" width="60" height="" />
          <img v-if="is_kosher" id="logo" class="ml-2" style="display: inline-block;"
               src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/kosher.jpg"
               alt="Halal Logo" width="60" height="" />
        </div>
      </div>
      <div class="vx-row mb-0 mt-0">
        <img id="logo" class="ml-2"
             src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
             alt="Logo" width="40" height="" />
        <h6 class="ml-4 mt-1" style="color: #000000; font-size: 10px !important;">
          Innovation House, Abex Road, Newbury, Berkshire, RG14 5EY
        </h6>
      </div>
    </vx-card>
      </main>
    </div>
    </body>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
const UlRepository = RepositoryFactory.get('ul');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import {Printd} from "printd";
import moment from "moment";
import vSelect from 'vue-select'

function initialState() {
  return {
    open: false,
    orderDetails: {},
    labelData: [],
    quantity: '',
    best_before: '',
    customer_item_code: null,
    groupedLabelData: {
      UNI: []
    },
    label_images: [],
    print_pack_size: 5
  }
}

export default {
  name: 'LabelPdfPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(orderDetails, data) {
      try {
        Object.assign(this.$data, initialState());
        this.open = true;
        this.orderDetails = orderDetails
        this.quantity = data.quantity
        this.customer_item_code = data.customer_item_code
        this.best_before = moment( this.orderDetails.work_order_date , "DD/MM/YYYY").add(this.orderDetails.expiration_months, 'months').format('DD/MM/YYYY'),
        await this.getLabelData()
      } catch (error) {

      }
    },
    async getLabelData() {
      const vue = this;
      await this.$vs.loading({
        container: '#formulation-label-pop-up',
        scale: 0.45
      })
      try {
        const { data } = await UlRepository.getFormulationLabel(this.orderDetails.formulation_code.replace('-', ''));
        this.labelData = data.data
        this.groupedLabelData = _.groupBy(this.labelData, label => label.data_code);
        this.label_images = this.labelData.filter((x) => x.data.includes('.png')).map((y) => y.data)
        for (let i of Array(4 - this.label_images.length).keys()) {
          this.label_images.push('no-symbol.png')
        }
      } catch (e) {
        this.$vs.loading.close('#formulation-label-pop-up > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formulation-label-pop-up > .con-vs-loading')
    },
    onClickPrint() {
      let printContents = document.getElementById('printDiv').innerHTML;
      let originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      location.reload()

//       const d = new Printd()
//       const styles = `html,
//   body {
//     -webkit-print-color-adjust: exact !important;
//   }
//   body {
//     position: relative;
//     margin: 0 auto;
//     color: #000000;
//     background: #FFFFFF;
//     font-family: Arial, sans-serif;
//     font-size: 14px;
//     line-height: 1.6;
//   }
//
//   div#full-wrap {
//     width: 40cm;
//     max-width: 100%;
//     margin: 0 auto;
//   }
// `
//       d.print(document.getElementById('myelement'), [styles])
    },
  },
  computed: {
    UNI: function () {
      const find = this.labelData.find((x) => x.data_code === 'UNI')
      if(find) { return find.data }
    },
    PYST: function () {
      const find = this.labelData.find((x) => x.data_code === 'PYST')
      if(find) { return find.data }
    },
    ODR: function () {
      const find = this.labelData.find((x) => x.data_code === 'ODR')
      if(find) { return find.data }
    },
    PGI: function () {
      const find = this.labelData.find((x) => x.data_code === 'PGI')
      if(find) { return find.data }
    },
    FPC: function () {
      const find = this.labelData.find((x) => x.data_code === 'FPC')
      if(find) { return find.data }
    },
    is_halal: function () {
      return ['certified'].includes(this.orderDetails.formulation_halal)
    },
    is_kosher: function () {
      return ['certified'].includes(this.orderDetails.formulation_kosher)
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },
}
</script>

<style scoped>
.add-new-carrier >>> .vs-popup {
  min-width: 70% !important;
}
/* style sheet for "letter" printing */
@media print {
  @page  {
    size: A5 landscape;
  }
  #printDiv {
    font-size: 2px !important;
  }
}

</style>
